import { updateProgressButton } from "@redux-core/utils";

export const updateShiftFormButton = (value, callback) => dispatch => {
	dispatch(
		updateProgressButton({
			module: "admin",
			property: "shifts.form.buttonStatus",
			value,
			callback,
		}),
	);
};

export default {
	updateShiftFormButton,
};
